"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatePickerState = void 0;
var react_1 = require("react");
var useDatePickerState = function (_a) {
    var _b = _a.withPortal, withPortal = _b === void 0 ? false : _b, portalId = _a.portalId, onDateSelect = _a.onDateSelect;
    var _c = (0, react_1.useState)(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = (0, react_1.useState)(false), portalOpen = _d[0], setPortalOpen = _d[1];
    var cleanupPortalBackdrop = (0, react_1.useCallback)(function (id) {
        var portal = document.getElementById(id);
        if (portal) {
            var portalOverlay = portal.querySelector('.react-datepicker__portal');
            if (portalOverlay) {
                portalOverlay.remove();
            }
        }
    }, []);
    var handleDateChange = (0, react_1.useCallback)(function (date) {
        if (onDateSelect) {
            onDateSelect(date);
        }
        if (!withPortal) {
            setIsOpen(false);
        }
        else {
            setPortalOpen(false);
            cleanupPortalBackdrop(portalId);
        }
    }, [withPortal, portalId, onDateSelect, cleanupPortalBackdrop]);
    var handlePortalClick = (0, react_1.useCallback)(function () {
        if (withPortal) {
            setPortalOpen(function (prev) {
                var newState = !prev;
                if (!newState) {
                    cleanupPortalBackdrop(portalId);
                }
                return newState;
            });
        }
    }, [withPortal, portalId, cleanupPortalBackdrop]);
    var handleInputClick = (0, react_1.useCallback)(function () {
        if (withPortal) {
            handlePortalClick();
        }
        else {
            setIsOpen(function (prev) { return !prev; });
        }
    }, [withPortal, handlePortalClick]);
    // Handle clicks outside the datepicker
    var handleClickOutside = (0, react_1.useCallback)(function (e) {
        if (!withPortal) {
            setIsOpen(false);
            return;
        }
        var portalElement = document.getElementById(portalId);
        if (!portalElement)
            return;
        var clickedElement = e.target;
        // Check if click was inside this specific portal
        var isClickInPortal = portalElement.contains(clickedElement);
        var isClickOnDatepickerInput = clickedElement.closest('.react-datepicker-wrapper');
        if (!isClickInPortal && !isClickOnDatepickerInput) {
            setPortalOpen(false);
            cleanupPortalBackdrop(portalId);
        }
    }, [withPortal, portalId, cleanupPortalBackdrop]);
    (0, react_1.useEffect)(function () {
        if (withPortal && portalOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            return function () {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [withPortal, portalOpen, handleClickOutside]);
    (0, react_1.useEffect)(function () {
        return function () {
            if (withPortal) {
                cleanupPortalBackdrop(portalId);
            }
        };
    }, [withPortal, portalId, cleanupPortalBackdrop]);
    var datePickerProps = __assign({ open: withPortal ? portalOpen : isOpen, onInputClick: handleInputClick, onChange: handleDateChange }, (withPortal ? {
        withPortal: true,
        portalId: portalId,
        onCalendarOpen: handlePortalClick,
        onCalendarClose: handlePortalClick,
    } : {
        onClickOutside: function () { return setIsOpen(false); }
    }));
    return {
        datePickerProps: datePickerProps,
        isOpen: withPortal ? portalOpen : isOpen
    };
};
exports.useDatePickerState = useDatePickerState;
